import React, { Component } from 'react';
import { Row, Col, Card, Button, DatePicker, Select } from 'antd';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import ProjectTable from './ProjectTable';
import './page-project.less';
import ProjectStatusSelect from '../../components/public/ProjectStatusSelect';
import SearchSelectComponent, { SearchSelectOption } from '../../components/public/SearchSelectComponent';
import ProjectManagerSelect from '../../components/public/ProjectManagerSelect';
import ProjectService from '../../service/project/ProjectService';
import { PROJECT_SERVICE_CATEGORY_OPTIONS } from './project-constants';

interface ProjectPageProps extends RouteComponentProps {}

interface ProjectPageState {
    beginDate: string | null;
    endDate: string | null;
    statusList: number[] | null;
    serviceCategory: string | null;
    companyId: number | null;
    customerManagerId: number | null;
    projectManagerAdminId: number | null;
    companyOptions: SearchSelectOption[];
    customerManagerOptions: SearchSelectOption[];
}

class ProjectPage extends Component<ProjectPageProps, ProjectPageState> {
    state: ProjectPageState = {
        beginDate: null,
        endDate: null,
        statusList: null,
        serviceCategory: null,
        companyId: null,
        customerManagerId: null,
        projectManagerAdminId: null,
        companyOptions: [],
        customerManagerOptions: [],
    };

    projectTableRef: ProjectTable;

    isMyProjectPage = () => this.props.location.pathname === '/app/my/project/list';

    getBreadcrumbs = () => this.isMyProjectPage() ? ['我的', '我的项目'] : ['项目管理', '项目列表'];

    getPageTitle = () => this.isMyProjectPage() ? '我的项目列表' : '项目列表';

    async componentDidMount() {
        await this.loadOptions();
        if (this.projectTableRef) {
            await this.projectTableRef.getProjectTableData(1,
                this.state.beginDate,
                this.state.endDate,
                this.state.statusList,
                this.state.serviceCategory,
                this.state.companyId,
                this.state.customerManagerId,
                this.state.projectManagerAdminId
            );
        }
    }

    loadOptions = async () => {
        const baseOptionsResponse = await ProjectService.getProjectBaseOptions();
        if (baseOptionsResponse && baseOptionsResponse.data) {
            const companyOptions = (baseOptionsResponse.data.companyOptions || [])
                .map((item: any) => ({ key: item.id, value: item.name }));
            this.setState({ companyOptions });

            if (!this.isMyProjectPage()) {
                const customerManagerOptions = (baseOptionsResponse.data.customerManagerOptions || [])
                    .map((item: any) => ({ key: item.id, value: item.name }));
                this.setState({ customerManagerOptions });
            }
        }

        if (this.isMyProjectPage()) {
            const myProjectResponse = await ProjectService.getMyProjectList({
                queryParam: {},
                pageNo: 1,
                pageSize: 999999,
            });
            if (myProjectResponse && myProjectResponse.data && myProjectResponse.data.projectInfoList) {
                const records = myProjectResponse.data.projectInfoList.records || [];
                const managerOptionMap = new Map<number, SearchSelectOption>();
                records.forEach((item: any) => {
                    if (item.customerManagerId && item.customerManagerName) {
                        managerOptionMap.set(item.customerManagerId, { key: item.customerManagerId, value: item.customerManagerName });
                    }
                });
                this.setState({ customerManagerOptions: Array.from(managerOptionMap.values()) });
            }
            return;
        }
    };

    handleQueryButtonClick = async () => {
        if (this.projectTableRef) {
            await this.projectTableRef.getProjectTableData(1,
                this.state.beginDate,
                this.state.endDate,
                this.state.statusList,
                this.state.serviceCategory,
                this.state.companyId,
                this.state.customerManagerId,
                this.state.projectManagerAdminId
            );
            this.projectTableRef.setPaginationPage(1);
        }
    };

    handleAddButtonClick = () => {
        window.location.href = '/#/app/project/manager';
    };

    handleExportButtonClick = async () => {
        if (this.projectTableRef) {
            await this.projectTableRef.exportProjectData();
        }
    };

    render() {
        return (
            <div className="gutter-project_container">
                <BreadcrumbCustom breads={this.getBreadcrumbs()} />
                <Row gutter={5}>
                    <Col md={23}>
                        <Card title={this.getPageTitle()} bordered={false}>
                            <div className="project-filter-container">
                                <div className="project-filter-row">
                                    <div className="project-filter-item">
                                        <label className="label-project_time">项目时间：</label>
                                        <DatePicker.RangePicker
                                            className="picker-project_time"
                                            allowEmpty={[true, true]}
                                            format="YYYY-MM-DD"
                                            onChange={(values) => {
                                                this.setState({
                                                    beginDate: values && values[0] ? values[0].format('YYYY-MM-DD') : null,
                                                    endDate: values && values[1] ? values[1].format('YYYY-MM-DD') : null,
                                                });
                                            }}
                                        />
                                    </div>

                                    <div className="project-filter-item">
                                        <label className="label-project_status">状态：</label>
                                        <ProjectStatusSelect
                                            mode="multiple"
                                            allowClear
                                            value={this.state.statusList || undefined}
                                            onChange={(value) => this.setState({ statusList: value && value.length > 0 ? value : null })}
                                        />
                                    </div>

                                    <div className="project-filter-item">
                                        <label className="label-project_category">服务类别：</label>
                                        <Select
                                            className="select-project_category"
                                            allowClear
                                            value={this.state.serviceCategory || undefined}
                                            onChange={(value) => this.setState({ serviceCategory: value || null })}
                                            placeholder="请选择"
                                        >
                                            {PROJECT_SERVICE_CATEGORY_OPTIONS.map(item => (
                                                <Select.Option key={item} value={item}>{item}</Select.Option>
                                            ))}
                                        </Select>
                                    </div>

                                    {!this.isMyProjectPage() && (
                                        <div className="project-filter-actions project-filter-actions-first-row">
                                            <Button className="button-project_export" onClick={this.handleExportButtonClick}>
                                                导出查询结果
                                            </Button>
                                        </div>
                                    )}
                                </div>

                                <div className="project-filter-row">
                                    <div className="project-filter-item">
                                        <label className="label-project_company">客户：</label>
                                        <SearchSelectComponent
                                            className="select-project_company"
                                            optionProps={this.state.companyOptions}
                                            onChange={(key) => this.setState({ companyId: key })}
                                            onClear={() => this.setState({ companyId: null })}
                                            allowClear
                                            placeholder="客户公司"
                                        />
                                    </div>

                                    <div className="project-filter-item">
                                        <label className="label-project_cm">客户经理：</label>
                                        <SearchSelectComponent
                                            className="select-project_cm"
                                            optionProps={this.state.customerManagerOptions}
                                            onChange={(key) => this.setState({ customerManagerId: key })}
                                            onClear={() => this.setState({ customerManagerId: null })}
                                            allowClear
                                            placeholder="客户经理"
                                        />
                                    </div>

                                    <div className="project-filter-item">
                                        <label className="label-project_pm">项目经理：</label>
                                        <ProjectManagerSelect
                                            className="select-project_pm"
                                            allowClear
                                            value={this.state.projectManagerAdminId}
                                            onChange={(value) => this.setState({ projectManagerAdminId: value || null })}
                                            placeholder="请选择"
                                        />
                                    </div>

                                    <div className="project-filter-actions">
                                        <Button className="button-project_query" type="primary" onClick={this.handleQueryButtonClick}>
                                            查询
                                        </Button>

                                        {!this.isMyProjectPage() && (
                                            <Button className="button-project_add" type="primary" onClick={this.handleAddButtonClick}>
                                                新建项目
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <ProjectTable
                                isMyProjectPage={this.isMyProjectPage()}
                                ref={(ref) => (this.projectTableRef = ref)}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default withRouter(ProjectPage);
